import React from "react";
import { useNavigate } from "react-router-dom";
import AuthHeader from "../../component/users/Header/AuthHeader";
import AuthFooter from "../../component/users/Footer/AuthFooter";
import { Box } from "@mui/material";
import footballBg from "../../assets/banners/login-football.png";
import pageantBg from "../../assets/banners/login-pageant.png";
import {
  BEAUTY_PAGEANT_LABEL,
  setFootballFlow,
  setPageantFlow,
} from "../../utils/homeFlow";

/**
 * Login / auth background: Football (left) + Fashion Designers & Beauty Pageant Events (right).
 * Theme labels switch the home flow the same way as the category chooser.
 */
const Layout = ({ children }) => {
  const navigate = useNavigate();

  const goFootball = () => {
    setFootballFlow();
    navigate("/");
  };

  const goPageant = () => {
    setPageantFlow();
    navigate("/competitions");
  };

  return (
    <>
      <AuthHeader />

      <Box className="onboarding_screen">
        <Box
          className="onboarding_bg_half onboarding_bg_football"
          aria-hidden
          sx={{ backgroundImage: `url(${footballBg})` }}
        />
        <Box
          className="onboarding_bg_half onboarding_bg_pageant"
          aria-hidden
          sx={{ backgroundImage: `url(${pageantBg})` }}
        />
        <Box className="onboarding_bg_veil" aria-hidden />
        <Box
          component="button"
          type="button"
          className="onboarding_theme_label football"
          onClick={goFootball}
        >
          Football
        </Box>
        <Box
          component="button"
          type="button"
          className="onboarding_theme_label pageant"
          onClick={goPageant}
        >
          {BEAUTY_PAGEANT_LABEL}
        </Box>
        <Box className="onboarding_inner">
          {children}
          <AuthFooter />
        </Box>
      </Box>
    </>
  );
};

export default Layout;
